<template>
    <div>
        <label :for="inputID">{{label}}</label>
        <div v-if="description !== ''" class="description-block">
            <p>{{description}}</p>
        </div>
        <select class="form-control" :id="inputID" @change="change">
            <option v-for="(option, index) in options"
                    :key="index" :value="option.value"
                    :selected="value === option.value">
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'LoveMapInput',
        props: {
            label: {
                type: String,
            },
            description: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
            },
            value:{

            }
        },
        computed: {
            inputID() {
                return `input-id-${this._uid}`;
            }
        },
        methods:{
            selectedOption(option) {
                // if (this.options.value) {
                //     // return option.value === this.mutableFlightSegment.country.code;
                // }
                // return false;
            },
            change(event){
                this.$emit('input',event.target.value)
            }
        }
    }
</script>

<style scoped lang="scss">
    .description-block{
        text-align: left;
        p {
            font-style: italic;
            vertical-align: baseline;
            display: inline-block;
            font-size: 10px;
            color: #444444;
        }
    }
    /*.lm-input {*/
    /*width: 300px;*/
    /*}*/
</style>

